import { Box, Stack, Tag, TagLabel } from '@chakra-ui/react';
import { kmToMi } from '@pelicargo/utils';

import { AirportInput, AirportInputProps } from './AirportInput';
import { trpc } from '../../config/trpc';

type Props = AirportInputProps & {
  currentAirportId: string;
  setValue: (name: string, value: any) => void;
};

// Wrapper on AirportInput that shows nearby airports as tags
export const NearbyAirportInput = ({ currentAirportId, setValue, ...props }: AirportInputProps) => {
  const { data: nearbyAirports } = trpc.getAirportsByDistance.useQuery(
    { id: currentAirportId },
    { enabled: !!currentAirportId },
  );

  return (
    <Box gridColumn="span 1">
      <AirportInput tabIndex={0} isRequired {...props} />
      <Stack direction="row" spacing={2} mt={2} flexWrap="wrap">
        {nearbyAirports?.map(({ document, geo_distance_meters }) => (
          <Tag
            key={document.id}
            size="sm"
            borderRadius="full"
            variant="outline"
            borderColor="offBlack"
            color="offBlack"
            fontWeight={document.airport_main_gateway ? 'bold' : 'normal'}
            cursor="pointer"
            onClick={() => setValue(props.name, document.id)}
            _hover={{ opacity: 0.8 }}
          >
            <TagLabel whiteSpace="nowrap">
              {`${document.id} (${kmToMi(geo_distance_meters.airport_latlng / 1000).toFixed(0)} mi)`}
            </TagLabel>
          </Tag>
        ))}
      </Stack>
    </Box>
  );
};
